module.exports = "/images/left-arrow-gold.svg?464b7bd8f984587838ba72c20afd3099";